var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 11.1427C3.15974 11.1427 0.857251 8.84026 0.857251 6C0.857251 3.15974 3.15974 0.857251 6 0.857251C8.84026 0.857251 11.1427 3.15974 11.1427 6C11.1427 8.84026 8.84026 11.1427 6 11.1427Z",
    fill: "#F26B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 9.4291H6.42952V4.7146H5.57227V9.4291Z",
    fill: "#F26B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00017 3.8563C5.64519 3.8563 5.35742 3.56853 5.35742 3.21355C5.35742 2.85857 5.64519 2.5708 6.00017 2.5708C6.35515 2.5708 6.64292 2.85857 6.64292 3.21355C6.64292 3.56853 6.35515 3.8563 6.00017 3.8563Z",
    fill: "#F26B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrangeIcon);
export default __webpack_public_path__ + "static/media/warning-orange-icon.9489224c68b9175f52c4e8f7eccba6a9.svg";
export { ForwardRef as ReactComponent };